import Swiper from "swiper";
const gallery = () => {

    const projectGallery = document.querySelector(".project-gallery");
    const gallerySwitch = document.querySelector(".project-gallery__switch");
    const galleryBtns = document.querySelectorAll("[data-gallery]");
    const galleryClose = document.querySelectorAll("[data-close]");
    const body = document.querySelector("body");
    const gallerySlider = document.querySelector(".project-gallery__views");
    let gallerySwiper
    if (gallerySlider) {
        gallerySwiper = new Swiper(gallerySlider, {
            loop: true,
            noSwiping: true,
            noSwipingClass: "zoom-image",
            navigation: {
                nextEl: ".project-gallery .splide__arrow--next",
                prevEl: ".project-gallery .splide__arrow--prev",
            }
        });
        const activeSlide = gallerySwiper.slides[gallerySwiper.activeIndex];
        projectGallery.dataset.mode = activeSlide.dataset.sliderMode;
        const counter = document.querySelector(`.project-gallery__counter-current[data-type='${activeSlide.dataset.sliderMode}']`);
        counter.innerText = activeSlide.dataset.typeIndex;

        gallerySwiper.on("slideChange", function(swiper){
            const nextIndex = swiper.activeIndex;
            const nextSlide = swiper.slides[nextIndex];
            const counter = document.querySelector(`.project-gallery__counter-current[data-type='${nextSlide.dataset.sliderMode}']`);
            projectGallery.dataset.mode = nextSlide.dataset.sliderMode;
            counter.innerText = nextSlide.dataset.typeIndex;
        });

        galleryClose.forEach(item => {
            item.addEventListener("click", function(e) {
               projectGallery.classList.remove("open");
               body.classList.remove("overflow");
            });
        });

        gallerySwitch.addEventListener("click", function(){
            const view = projectGallery.dataset.mode;
            const slides = gallerySwiper.slides;
            for (let i = 0; i < slides.length; i++) {
                const selector = view === "views" ? "visualisations" : "views";
                if (slides[i].dataset.sliderMode === selector && slides[i].dataset.typeIndex === "1") {
                    gallerySwiper.slideTo(i);
                }
            }
        });



        galleryBtns.forEach(item => {
            item.addEventListener("click", function(e) {
                const slides = gallerySwiper.slides;
                for (let i = 0; i < slides.length; i++) {
                    if (parseInt(slides[i].dataset.typeIndex) === parseInt(item.dataset.index) + 1 && slides[i].dataset.sliderMode === item.dataset.gallery) {
                        const index = parseInt(slides[i].dataset.index) + 1;
                        gallerySwiper.slideTo(index);
                        projectGallery.classList.add("open");
                        body.classList.add("overflow");
                        return;
                    }
                }
            });
        })
    }

    if (projectGallery) {
        projectGallery.addEventListener("click", function(e){
            if (e.target.dataset.hasOwnProperty("zoom")) {
                const slide = e.target.closest(".swiper-slide");
                if (e.target.dataset.zoom === "in") {
                    if (slide.classList.contains("zoom") && !slide.classList.contains("zoom-max")) {
                        slide.classList.add("zoom-max");
                    }
                    slide.classList.add("zoom");
                }
                else {
                    if (slide.classList.contains("zoom-max")) {
                        slide.classList.remove("zoom-max");
                    }
                    else {
                        slide.classList.remove("zoom");
                    }
                }
            }
        });

        let dragActive = false;
        const positions = {
            startX: 0,
            startY: 0,

            startLeft: 0,
            startTop: 0,

            clientX: 0,
            clientY: 0,

            offsetLeft: 0,
            offsetRight: 0,
            offsetTop: 0,
            offsetBottom: 0,

            width: 0,
            height: 0,

            imgWidth: 0,
            imgHeight: 0,
        }

        function moveStart (e) {
            if (e.target.classList.contains("zoom-image")) {
                e.preventDefault();
                e.stopPropagation();
                positions.startX = e.clientX ? e.clientX : e.targetTouches[0].screenX;
                positions.startY = e.clientY ? e.clientY : e.targetTouches[0].screenY;

                const rect = e.target.closest("div").getBoundingClientRect();
                const rectImg = e.target.getBoundingClientRect();

                positions.offsetLeft = rect.left;
                positions.offsetTop = rect.top;
                positions.offsetRight = window.innerWidth - (rect.left + rect.width);
                positions.offsetBottom = window.innerHeight - (rect.top + rect.height);

                positions.width = rect.width;
                positions.height = rect.height;

                positions.imgWidth = rectImg.width;
                positions.imgHeight = rectImg.height;

                positions.startLeft = e.target.style.left ? parseInt(e.target.style.left) : 0;
                positions.startTop = e.target.style.top ? parseInt(e.target.style.top) : 0;

                dragActive = true;
            }
        }

        function move(e) {
            if (dragActive && e.target.classList.contains("zoom-image")) {
                e.preventDefault();
                e.stopPropagation();
                positions.clientX = e.clientX ? e.clientX : e.targetTouches[0].screenX;
                positions.clientY = e.clientY ? e.clientY : e.targetTouches[0].screenY;

                // X
                let left = positions.startLeft + (positions.clientX - positions.startX);
                if (left > 0) {
                    left = 0;
                }
                if (left < -(positions.imgWidth) + positions.width) {
                    left = -(positions.imgWidth) + positions.width;
                }
                e.target.style.left = left + "px";

                // Y
                let top = positions.startTop - (positions.startY - positions.clientY);
                if (top > 0) {
                    top = 0;
                }
                if (top < -(positions.imgHeight) + positions.height) {
                    top = -(positions.imgHeight) + positions.height;
                }
                e.target.style.top = top + "px";
            }
        }

        projectGallery.addEventListener("mousedown", function(e) {
            moveStart(e);
        });
        projectGallery.addEventListener("touchstart", function(e) {
            moveStart(e);
        });
        projectGallery.addEventListener("mousemove", function(e) {
            move(e);
        });
        projectGallery.addEventListener("touchmove", function(e) {
            move(e);
        });
        projectGallery.addEventListener("mouseup", function(e) {
            dragActive = false;
        });
        projectGallery.addEventListener("touchend", function(e) {
            dragActive = false;
        });
    }
}

export default gallery;